import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=59e505af&scoped=true&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=59e505af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e505af",
  null
  
)

export default component.exports